import React, { PureComponent, ReactNode, CSSProperties } from 'react'
import { connect, DispatchProp } from 'react-redux'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { AnyAction } from 'redux'
import { MenuItem } from '../../../components'
import { IBase, ISearchedType, IServiceInfo, IStop } from '../../../models'
import { LiteralsService } from '../../../services'
import { searchStopCoordinatesAction, searchStopsAction, setMapChangedCenterAction, setShowSingleStopModalAction, setSingleBusStopDirectionAction } from '../../../store/actions'
import { IStoreState } from '../../../store/states'
import StyledUl from './styles'
import { urls } from '../../../routing'

interface IProps extends DispatchProp, RouteComponentProps {
  stopsSearched: IBase[]
  serviceInfos: IServiceInfo[]
  inStop?: IStop | null
  outStop?: IStop | null
  outBusStops?: IStop[]
}
interface IState {
  forwardDirection: boolean
}

const itemStyle: CSSProperties = {
  width: '100%',
  justifyContent: 'flex-start',
  alignItems: 'center',
  padding: '10px'
}

class SearchStopsView extends PureComponent<IProps, IState> {

  constructor(props: IProps) {
    super(props)

    this.state = {
      forwardDirection: true
    }
  }

  public render(): ReactNode {
    const { stopsSearched, serviceInfos } = this.props
    const { forwardDirection } = this.state

    const filteredStops = stopsSearched.filter((s: any) => forwardDirection ? (s.direction == 0 || s.direction == null) : (s.direction == 1 || s.direction == null))

    const stops = filteredStops.map((s: any) => {
      const commonServices: number = serviceInfos.filter((serviceInfo) => serviceInfo.selected && serviceInfo.stops.some(stop => stop.id === s.id)).length
      if (s.location) {
        return (
          <MenuItem
            key={ `${s.serviceInfo.id}-${s.id}` }
            label={ `${s.name}${commonServices > 1 ? ` (${s.serviceInfo.name})`: ''}`}
            code={ s.code }
            onClick={ () => this.onClickStopServiceSearched(s) }
            containerStyles={ itemStyle }
            frontIcon={ this.isDisabled(s) ? "stopDisabled" : "stop" }
          />
        )
      } else {
        return (
          <MenuItem
            key={ s.id }
            label={ `${s.name}${commonServices > 1 ? ` (${s.serviceInfo.name})`: ''}`}
            onClick={ () => this.onClickStopSearched(s) }
            containerStyles={ itemStyle }
            frontIcon="pin"
          />
        )
      }
    })

    if (!stopsSearched.length) {
      return (
        <MenuItem
          label={ LiteralsService.get('myUbication', true) }
          onClick={ this.onClickMyLocation }
          frontIcon={ 'myLocation' }
          containerStyles={ { width: '100%', padding: '10px' } }
        />
      )
    } else {
      return (
        <StyledUl>
          { stops }
        </StyledUl>
      )
    }
  }

  private isDisabled(stop: IStop): boolean {
    const { outBusStops, inStop, outStop } = this.props
    if ((inStop || outStop) && !!outBusStops && outBusStops.length === 0) return true

    const isSelectable = !!outBusStops && outBusStops.some(dbs => dbs.id === stop.id)
    const isOrigin =
      inStop == null
        ? false
        : inStop && inStop.id === stop.id

    const checkIfIsRestricted = this.getRestrictedOrigins() ? this.getRestrictedOrigins().includes(stop.id) : false;
    if (isOrigin) return false
    return inStop != null ? !!outBusStops && !!outBusStops.length && !isSelectable : checkIfIsRestricted
  }

  private getRestrictedOrigins = (): number[] => {
      const { serviceInfos } = this.props
      let restrictedOrigins: any = []
  
      serviceInfos.forEach((serviceInfo: IServiceInfo) => {
        serviceInfo.restrictedOrigins && serviceInfo.restrictedOrigins.forEach((restrictedOrigin: any) => {
          if(!(restrictedOrigins.filter((ro: any) => ro === restrictedOrigin).length > 0)) {
            restrictedOrigins.push(restrictedOrigin)
          }
        })
      })
  
      let ro = restrictedOrigins.slice(0)
      ro.forEach((r: any) => {
        serviceInfos.forEach((serviceInfo: IServiceInfo) => {
          if((serviceInfo.stops.filter((ss: any) => r === ss.id).length > 0)) {
            if(!(serviceInfo.restrictedOrigins.filter((o: any) => r === o).length > 0)) {
              var index = restrictedOrigins.indexOf(r)
              if (index !== -1) {
                restrictedOrigins.splice(index, 1)
              }
            }
          }
        })
      })
    
      return restrictedOrigins
    }

  private onClickMyLocation = () => {
    const { dispatch } = this.props
    dispatch(searchStopCoordinatesAction({ type: ISearchedType.location } as any))
  }

  private onClickStopServiceSearched = (stop: IStop) => {
    const { dispatch, history } = this.props
    if (stop.serviceInfo.singleStopReservations) {
      if (stop.serviceInfo.roundTrips) {
        dispatch(setSingleBusStopDirectionAction(true, stop))
        const name = new URLSearchParams(location.search).get('name') ?? history.location.state?.name
        const lastName = new URLSearchParams(location.search).get('lastName') ?? history.location.state?.lastName
        const email = new URLSearchParams(location.search).get('email') ?? history.location.state?.email
        const townId = new URLSearchParams(location.search).get('townId') ?? history.location.state?.townId
    
        history.push(urls.newReservationDateStep, {
          userData: {
            name,
            lastName,
            email
          },
          townId: townId
        })
      } else {
        dispatch(setShowSingleStopModalAction(true, stop))
      }
    } else {
      dispatch(searchStopsAction(stop.name))
      dispatch(setMapChangedCenterAction({
        latitude: stop.location.geometry.coordinates[1],
        longitude: stop.location.geometry.coordinates[0]
      }))
      dispatch(searchStopCoordinatesAction({ ...stop, type: ISearchedType.stop }))
    }
  }

  private onClickStopSearched = (suggestion: IBase) => {
    const { dispatch } = this.props

    dispatch(searchStopsAction(suggestion.name))
    dispatch(searchStopCoordinatesAction({ ...suggestion, type: ISearchedType.google }))
  }
}

const mapStateToProps = ({ newReservation }: IStoreState) => ({
  stopsSearched: newReservation.stopsSearched,
  serviceInfos: newReservation.serviceInfos,
  outBusStops: newReservation.destinationBusStops,
  inStop: newReservation.pickedOriginBusStop,
  outStop: newReservation.pickedDestinationBusStop
})

export default withRouter(connect(mapStateToProps)(SearchStopsView))
